import React, { useEffect, useMemo, useRef, useState } from "react";
import cn from "classnames";
import style from "./common.module.scss";
import moment from "moment";
import "moment/locale/ru";
import OrdersSectionItemTableStatus from "../../orders-new/section-item/components/OrdersSectionItemTableStatus";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import NotificationIconNew from "../../shared/icons/NotificationIconNew";
import NotificationsPopup from "../../notification/NotificationsPopup/NotificationsPopup";
import LineFlexIcon from "../../shared/icons/LineFlexIcon";
import { useNavigate } from "react-router-dom";

moment.locale("ru");

const OrdersAviationTableMobile = ({
  items = [],
  isExpeditor,
  companyName,
  onForceUpdate,
  isShowOrderSolution,
  notificationsMap = {},
  setNotificationsMap,
  isMarketplacePage = false
}) => {
  const { t } = useTranslation();
  const tableRef = useRef(null);
  const notificationRefs = useRef([]);
  const navigate = useNavigate();

  const [isOpenInfo, setIsOpenInfo] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const { user } = useSelector((state) => state);
  const [openNotificationOrderId, setOpenNotificationOrderId] = useState(null);

  const handleToggleNotification = (orderId) => {
    setOpenNotificationOrderId((prevId) => (prevId === orderId ? null : orderId));
  };

  const tableHead = useMemo(() => {
    const columns = [
      {
        name: t("ordersAvailablePage.tableHead.fromToLabel"),
        isSortable: false,
        key: "addressFromTo",
      },
      {
        name: t("ordersAvailablePage.tableHead.status"),
        isSortable: false,
        key: "status",
      },
      {
        name: "",
        isSortable: false,
      },
    ];

    return columns;
  }, [user?.type, t]);

  return (
    <div className={cn(style.mobile_wrapper, "table-responsive")} ref={tableRef}>
      <table className="table">
        <thead>
          <tr>
            {tableHead.map((item, idx) => (
              <th scope="col" key={"head-" + idx}>
                <div className={style.tableHead}>{item.component ? item.component : item.name}</div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
            {items.map((item, idx) => {
              if (!notificationRefs.current[idx]) {
                notificationRefs.current[idx] = React.createRef();
              }
              const unreadCount = (notificationsMap[item.id] || []).filter(n => !n.isRead).length;
            
              return (
                <tr key={idx}>
                  <td
                    onClick={() =>
                      isMarketplacePage
                        ? navigate("/marketplace/aviation/order/" + item.id)
                        : navigate("/aviation/order/" + item.id, {
                            state: { isShowOrderSolution: true },
                          })
                    }
                    className={cn("cursor-pointer", style.mobile_wrapper_col)}
                  >
                    <LineFlexIcon height={70} />
                    <div className={style.table_col}>
                      <div className={style.table_col_country}>
                        {item.cityFromName}
                      </div>
                      <span className={style.table_col_summary}>
                          {moment
                            .utc(item.shippingDate)
                            .startOf("day")
                            .add(item.shippingHourFrom, "hours")
                            .format("D MMMM, HH:mm")}
                        </span>
                      <div className={style.table_col_country}>
                        {item.cityToName}
                      </div>
                      <span className={style.table_col_summary}>
                        {moment
                          .utc(item.unloadingDate)
                          .startOf("day")
                          .add(item.unloadingHourFrom, "hours")
                          .format("D MMMM, HH:mm")}
                      </span>
                    </div>
                  </td>
                  <td
                    onClick={() =>
                      isMarketplacePage
                        ? navigate("/marketplace/aviation/order/" + item.id)
                        : navigate("/aviation/order/" + item.id, {
                            state: { isShowOrderSolution: true },
                          })
                    }
                    className="cursor-pointer"
                  >
                    <div>
                      <OrdersSectionItemTableStatus
                        timeSnapshotKey={item}
                    tenderDateEnd={item?.tenderDateEnd}
                        status={item.status}
                        driverName={item.driverName}
                        driverSurname={item.driverSurname}
                      />
                    </div>
                  </td>
                  <td>
                    <div className={style.table_col_arrow}>
                      <div
                        className={cn("ms-auto", style.notification)}
                        ref={notificationRefs.current[idx]}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleToggleNotification(item.id);
                        }}
                      >
                        <NotificationIconNew />
                        {unreadCount > 0 && (
                          <div className={style.notification_count}>{unreadCount}</div>
                        )}
                      </div>

                      <NotificationsPopup
                        notifications={notificationsMap[item.id] || []}
                        orderData={item}
                        orderType="aviation"
                        isOpen={openNotificationOrderId === item.id}
                        onClose={() => {
                          setOpenNotificationOrderId(null);
                        }}
                        referenceElement={notificationRefs.current[idx]?.current}
                        onNotificationsRead={(readIds) => {
                          setNotificationsMap((prev) => ({
                            ...prev,
                            [item.id]: prev[item.id].map((notif) =>
                              readIds.includes(notif.id)
                                ? { ...notif, isRead: true, readDate: new Date() }
                                : notif
                            ),
                          }));
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default OrdersAviationTableMobile;
